import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { GoogleMapRecommendation } from "../Map/GoogleMapRecommendation";
import { DataLayerTypes } from "../../../types/enums";
import { useCurrentDataLayerTypeSelector } from "../../../store/projects/selectors";
import { setCurrentDataLayerType } from "../../../store/projects/actions";
import { dispatch } from "../../../store";

export const ClimateRisksCard: React.FC = () => {
  const currentDataLayerType = useCurrentDataLayerTypeSelector();

  const riskLayers = [
    {
      value: DataLayerTypes.TIDAL_HEIGHT,
      label: "Astronomical Tidal Height",
      path: "/data/tidal_height.tif",
    },
    {
      value: DataLayerTypes.FIRE_RISK,
      label: "Fire Risk",
      path: "/data/fire_risk.tif",
    },
    {
      value: DataLayerTypes.STORM_RISK,
      label: "Storm Risk",
      path: "/data/storm_risk.tif",
    },
  ];

  // Find current layer data
  const currentLayer = riskLayers.find((layer) => layer.value === currentDataLayerType);

  const [chartData, setChartData] = useState({
    labels: ["Low Risk", "Medium Risk", "High Risk"],
    datasets: [
      {
        data: [30, 45, 25],
        backgroundColor: ["#4ade80", "#fbbf24", "#ef4444"],
        barThickness: 40,
      },
    ],
  });

  const handleLayerChange = (value: DataLayerTypes) => {
    dispatch(setCurrentDataLayerType(value));
  };

  useEffect(() => {
    // Update chart data when layer changes
    if (currentLayer) {
      // You can add logic here to process GeoTIFF data and update chart
      // For now using placeholder data
      setChartData((prev) => ({
        ...prev,
        datasets: [
          {
            ...prev.datasets[0],
            data: [
              Math.random() * 30 + 20, // Random data for demonstration
              Math.random() * 30 + 20,
              Math.random() * 30 + 20,
            ],
          },
        ],
      }));
    }
  }, [currentDataLayerType]);

  return (
    <div className="grid grid-cols-2 gap-6">
      <div className="rounded-lg bg-white p-4 shadow-md">
        <div className="mb-4">
          <select
            value={currentDataLayerType}
            onChange={(e) => handleLayerChange(e.target.value as DataLayerTypes)}
            className="w-full rounded border p-2"
          >
            {riskLayers.map((layer) => (
              <option key={layer.value} value={layer.value}>
                {layer.label}
              </option>
            ))}
          </select>
        </div>
        <GoogleMapRecommendation
          mapContainerStyle={{ height: "500px", width: "100%" }}
          geoJsonObjects={[
            {
              type: "FeatureCollection",
              features: [],
            },
          ]}
          // Additional props for GeoTIFF overlay would go here
        />
      </div>

      <div className="rounded-lg bg-white p-4 shadow-md">
        <h3 className="mb-4 text-lg font-medium">
          {currentLayer ? currentLayer.label : ""} Distribution
        </h3>
        <div className="h-[400px]">
          <Bar
            data={chartData}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              plugins: {
                legend: { display: false },
                title: {
                  display: true,
                  text: "Risk Level Distribution",
                },
              },
              scales: {
                y: {
                  beginAtZero: true,
                  title: {
                    display: true,
                    text: "Area Coverage (%)",
                  },
                },
              },
            }}
          />
        </div>
      </div>
    </div>
  );
};
